import { BrowserModule } from '@angular/platform-browser';
import { NgModule, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { LoginComponent } from './login/login.component';
import { CasesComponent } from './cases/cases.component';
import { AuthService } from './services/auth.service';
import { BlockUiService } from './services/blockui.service';
import { BlockuiComponent } from './services/blockui/blockui.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FrantishexTableComponent } from './utility/frantishex-table/frantishex-table.component';
import { PersonComponent } from './person/person.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2DropdownModule } from 'ng2-material-dropdown';
import { ModalModule, TabsModule, DatepickerModule, PaginationModule } from 'ngx-bootstrap';
import { EditCaseComponent } from './cases/edit-case/edit-case.component';
import { CaseService } from './services/case.service';
import { PersonService } from './services/person.service';
import { StorageService } from './services/storage.service';
import { EditPersonComponent } from './person/edit-person/edit-person.component';
import { NomenclatureService } from './services/nomenclature.service';
import { HttpService } from './services/http.service';
import { FileService } from './services/file.service';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TextInputAutocompleteModule } from 'angular-text-input-autocomplete';
import { FrantishexAutoCompleterComponent } from './utility/frantishex-auto-completer/frantishex-auto-completer.component';
import { EditCaseMainComponent } from './cases/edit-case/edit-case-main/edit-case-main.component';
import { EditCaseSecondInstanceComponent } from './cases/edit-case/edit-case-second-instance/edit-case-second-instance.component';
import { EditCaseNakazatelnoComponent } from './cases/edit-case/edit-case-nakazatelno/edit-case-nakazatelno.component';
import { EditCaseIzpulnitelnoComponent } from './cases/edit-case/edit-case-izpulnitelno/edit-case-izpulnitelno.component';
import { EditCaseRaznoskiComponent } from './cases/edit-case/edit-case-raznoski/edit-case-raznoski.component';
import { EditCaseNotesComponent } from './cases/edit-case/edit-case-notes/edit-case-notes.component';
import { EditCaseHistoryComponent } from './cases/edit-case/edit-case-history/edit-case-history.component';
import { EditCasePrihodiComponent } from './cases/edit-case/edit-case-prihodi/edit-case-prihodi.component';
import { LibraryComponent } from './cases/edit-case/library/library.component';
import { ReportService } from './services/report.service';
import { TaskService } from './services/task.service';
import { ShowZadachiComponent } from './show-zadachi/show-zadachi.component';
import { ShowNasrocheniDelaComponent } from './show-nasrocheni-dela/show-nasrocheni-dela.component';
import { RowContentDelaComponent } from './show-nasrocheni-dela/row-content-dela/row-content-dela.component';
import { TwoDecimalsFormatPipe } from "src/app/utility/two-decimals-format.pipe";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { DecimalMaskDirective } from './directives/decimal-mask.directive';
export * from 'rxjs-compat';
import { APP_INITIALIZER } from '@angular/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { PercentFormatterDirective } from './directives/percent-formatter.directive';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SecurityUsersComponent } from './components/security-users/security-users.component';
import { StatusComponent } from './components/statuses/statuses.component';
import { VidSluchajAdminComponent } from './components/vid-sluchaj-admin/vid-sluchaj-admin.component';
import { SecurityService } from './services/security.service';
import { Paging2Component } from './shared/paging/paging2/paging2.component';
import { NotificationBellComponent } from './components/notification-bell/notification-bell.component';
import { MyCalendarComponent } from './my-calendar/my-calendar.component';
import { ChangeColorComponent } from './change-color/change-color.component';
import { NotificationConfigComponent } from './components/notification-config/notification-config.component';
import { AdminComponent } from './components/admin/admin.component';
import { WordTemplateAdminComponent } from './components/word-template-admin/word-template-admin.component';
import { WordTemplateService } from './services/word-template.service';
import { ExternalCasesComponent } from './external-cases/external-cases.component';
import { ExternalCaseService } from './services/external-case.service';
import { NationalHolidayAdminComponent } from './components/national-holiday-admin/national-holiday-admin.component';
import { ReportAdminComponent } from './components/report-admin/report-admin.component';
import { LawyerWorkloadAdminComponent } from './components/lawyer-workload-admin/lawyer-workload-admin.component';
import { VacationDialogComponent } from './vacation-dialog/vacation-dialog.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PreferencesComponent } from './preferences/preferences.component';



@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		CasesComponent,
		TopMenuComponent,
		BlockuiComponent,
		FrantishexTableComponent,
		PersonComponent,
		EditCaseComponent,
		EditPersonComponent,
		FrantishexAutoCompleterComponent,
		EditCaseMainComponent,
		EditCaseSecondInstanceComponent,
		EditCaseNakazatelnoComponent,
		EditCaseIzpulnitelnoComponent,
		EditCaseRaznoskiComponent,
		EditCaseNotesComponent,
		EditCaseHistoryComponent,
		EditCasePrihodiComponent,
		LibraryComponent,
		ShowZadachiComponent,
		ShowNasrocheniDelaComponent,
		RowContentDelaComponent,
		TwoDecimalsFormatPipe,
		ChangePasswordComponent,
		DecimalMaskDirective,
		CurrencyFormatterDirective,
		PercentFormatterDirective,
		SecurityUsersComponent,
		StatusComponent,
		VidSluchajAdminComponent,
		Paging2Component,
		NotificationBellComponent,
		MyCalendarComponent,
		ChangeColorComponent,
		NotificationConfigComponent,
		AdminComponent,
		WordTemplateAdminComponent,
		ExternalCasesComponent,
		NationalHolidayAdminComponent,
		VacationDialogComponent,
		ReportAdminComponent,
		LawyerWorkloadAdminComponent,
		DashboardComponent,
		PreferencesComponent
	],
	imports: [
		BrowserAnimationsModule,
		BsDatepickerModule.forRoot(),
		NgbModule.forRoot(),
		DatepickerModule.forRoot(),
		PaginationModule.forRoot(),
		ModalModule.forRoot(),
		TabsModule.forRoot(),
		RouterModule.forRoot(routes),
		Ng2DropdownModule,
		BrowserModule,
		FormsModule,
		HttpClientModule,
	],
	exports: [BrowserModule],
	providers: [AuthService,
		HttpService,
		FileService,
		CaseService,
		PersonService,
		NomenclatureService,
		BlockUiService,
		DecimalPipe,
		DatePipe,
		ReportService,
		TaskService,
		StorageService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		SecurityService,
		WordTemplateService,
		ExternalCaseService
	],
	entryComponents: [
		BlockuiComponent,
		RowContentDelaComponent
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
